import React from "react";
import { StaticQuery, graphql } from "gatsby";

export default ({ children }) => (
  <StaticQuery
    query={query}
    render={({ site, homepage }) => {
      return children({ site, homepage });
    }}
  />
);
const query = graphql`
  query IndexPageQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
      description
      keywords
      enableSplashPage
      splashLottieFile {
        asset {
          url
        }
      }
    }
    homepage: sanityHomePage {
      introLottieMobile {
        asset {
          url
        }
      }
      introLottieDesktop {
        asset {
          url
        }
      }
      featuredLinks {
        label
        url
        newTab
      }
      featuredLinksLottie {
        asset {
          url
        }
      }
      featuredLinksLottieText
      introTitleCopy
      _rawAboutCopy
      aboutButtonCopy
      introBackgroundVideo {
        asset {
          url
        }
      }
      enableMobileBackgroundVideo
      introBackgroundVideoMobile {
        asset {
          url
        }
      }
      clientsTitleCopy
      clientsSubtitleCopy
      clientsAfterCopy
      mobileLogoGrid {
        asset {
          _id
        }
      }
      desktopLogoGrid {
        asset {
          _id
        }
      }
      caseStudiesTitleCopy
      caseStudiesReadMoreCopy
      _rawContentOne(resolveReferences: { maxDepth: 10 })
      _rawContentTwo(resolveReferences: { maxDepth: 10 })
      selectedProjects: caseStudiesHighlighted {
        ... on SanityProject {
          id
          previewImage {
            asset {
              _id
            }
            alt
          }
          title
          descriptor
          slug {
            current
          }
        }
      }
    }
  }
`;
